/**
 * 错误码到多语言 key 的映射
 * 用于在网络层根据后端返回的错误码自动映射到对应的多语言文案
 */
export const ERROR_CODE_MAP: Record<number, string> = {
  // 用户相关错误
  20001: 'error.USER_NOT_EXIST',
  20002: 'error.USER_LOCK',
  20003: 'error.USER_PASSWORD_ERROR',
  20004: 'error.USER_STATUS_ERROR',
  20005: 'error.AUTH_LOGIN_ERROR',
  20006: 'error.EMAIL_EMPTY',
  20007: 'error.EMAIL_NOT_VERIFIED',
  20008: 'error.ADDRESS_NOT_EXIST',

  // 已存在相关错误
  20100: 'error.USER_NAME_EXIST',
  20101: 'error.MOBILE_EXIST',
  20102: 'error.EMAIL_EXIST',
  20103: 'error.COUNTRY_EXIST',
  20104: 'error.CURRENCY_EXIST',
  20105: 'error.TAG_EXIST',
  20106: 'error.TIME_ZONE_EXIST',
  20107: 'error.LANGUAGE_EXIST',
  20108: 'error.TYPE_EXIST',
  20109: 'error.AGREEMENT_EXIST',
  20110: 'error.PERM_IS_USED',
  20111: 'error.DEPT_IS_USED',
  20112: 'error.ROLE_IS_USED_USER',
  20113: 'error.ROLE_IS_USED_DEPT',
  20114: 'error.AREA_EXIST',
  20115: 'error.TAG_EMPTY_CONDITION',
  20116: 'error.CURRENCY_IS_USED',
  20117: 'error.TAX_NUMBER_REQUIRED',
  20118: 'error.ADDRESS_LINE2_REQUIRED',
  20119: 'error.ZIPCODE_REQUIRED',
  20120: 'error.CATEGORY_NOT_EXIST',
  20121: 'error.MOBILE_REQUIRED',
  20122: 'error.USER_DOMAIN_IS_NULL',
  20123: 'error.USER_NAME_OR_MOBILE_EXIST',
  20125: 'error.USER_NAME_OR_EMAIL_EXIST',
  20126: 'error.STORE_URL_EXIST',
  42008: 'confirmStoreConnectedWiio',
  42015: 'shopifyDomainUsedByOtherStore',
  20127: 'error.USER_SAVE_ERROR',
  20128: 'error.USER_CAPTCHA_ERROR',
  20129: 'error.USER_NOT_DINGTALK',
  20130: 'error.WRONG_PLATFORM',
  20131: 'error.WRONG_SIGN',
  20132: 'error.INVITER_NOT_EXIST',
  20133: 'error.EMAIL_REPEATED',
  20134: 'error.MUST_INPUT_EMAIL',
  20135: 'error.MUST_INPUT_PWD',
  20136: 'error.INVALID_INVITATION_CODE',
  20137: 'error.VERIFY_CODE_INCORRECT',
  20138: 'error.INVALID_PHONE_NUMBER',
  400: 'error.SERVER_BUSY',
  4002: 'error.PARAMETER_ERROR'
}

/**
 * 根据错误码获取多语言 key
 * @param code 错误码
 * @returns 多语言 key，如果不存在则返回 null
 */
export const getErrorI18nKey = (code: number): string | null => {
  return ERROR_CODE_MAP[code] || null
}
